<div *ngIf="updateAvailable && !dismissed"
     class="sticky top-0 left-0 right-0 z-[9999] text-white shadow-lg"
     [ngClass]="isDarkMode ? 'bg-emerald-700' : 'bg-emerald-600'">
  <div class="container mx-auto px-4">
    <div class="flex items-center justify-between gap-3 py-2">
      <div class="flex items-center gap-3 min-w-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
        </svg>
        <span class="text-sm font-medium truncate">
          A new version of the dashboard is available. Refresh to get the latest updates.
        </span>
      </div>

      <div class="flex items-center gap-2 flex-shrink-0">
        <button type="button" (click)="refresh()"
                class="bg-white text-emerald-700 hover:bg-emerald-50 px-3 py-1.5 rounded-lg font-semibold text-sm transition-colors">
          Refresh now
        </button>
        <button type="button" (click)="dismissed = true" aria-label="Dismiss"
                class="p-1.5 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
